import React from 'react';
import '../styles/components.css';

const CustomerCard = ({ image, text, subText, subText1 }) => {
    return (
        <article className='customer_card_article'>
            <img src={image} alt={subText + " logo"} />
            <p>{text}</p>
            <p><strong>{subText}</strong></p>
            <p>{subText1}</p>
        </article>
    );
};

export default CustomerCard;